export default {
  computed: {
    fontFamilyOptions () {
      return [
        { text: '---', value: null },
        { text: 'ゴシック', value: `'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: '明朝', value: `'Times New Roman', 'Hiragino Mincho ProN', 'ヒラギノ明朝 ProN', 'MS PMincho', 'ＭＳ Ｐ明朝', serif` },
        { text: 'Arial', value: `'Arial', 'Helvetica Neue', 'Helvetica', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: 'Arial Black', value: `'Arial Black', 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: 'Helvetica', value: `'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: 'ＭＳ ゴシック', value: `'MS Gothic', 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: 'ＭＳ Ｐゴシック', value: `'MS PGothic', 'ＭＳ Ｐゴシック', 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', Verdana, sans-serif` },
        { text: 'ＭＳ 明朝', value: `'MS Mincho', 'Times New Roman', 'Hiragino Mincho ProN', 'ヒラギノ明朝 ProN', 'MS PMincho', 'ＭＳ Ｐ明朝', serif` },
        { text: 'ＭＳ Ｐ明朝', value: `'MS PMincho', 'ＭＳ Ｐ明朝', 'Times New Roman', 'Hiragino Mincho ProN', 'ヒラギノ明朝 ProN', serif` },
        { text: 'Osaka', value: `Osaka, 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: 'Times New Roman', value: `'Times New Roman', 'Hiragino Mincho ProN', 'ヒラギノ明朝 ProN', 'MS PMincho', 'ＭＳ Ｐ明朝', serif` },
        { text: 'Verdana', value: `Verdana, 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', sans-serif` },
        { text: 'ヒラギノ角ゴ', value: `'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', 'Hiragino Sans', 'Helvetica Neue', 'Helvetica', 'Arial', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: 'ヒラギノ明朝', value: `'Hiragino Mincho ProN', 'ヒラギノ明朝 ProN', 'Times New Roman', 'MS PMincho', 'ＭＳ Ｐ明朝', serif` },
        { text: 'メイリオ', value: `Meiryo, 'メイリオ', 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
        { text: '游ゴシック', value: `'Yu Gothic Medium', '游ゴシック Medium', YuGothic, '游ゴシック体', 'Helvetica Neue', 'Helvetica', 'Arial', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, 'メイリオ', 'MS PGothic', 'ＭＳ Ｐゴシック', Verdana, sans-serif` },
      ]
    },
    fontSizeOptions () {
      return [
        { text: '---', value: null },
        { text: '9px', value: '9px' },
        { text: '10px', value: '10px' },
        { text: '11px', value: '11px' },
        { text: '12px', value: '12px' },
        { text: '13px', value: '13px' },
        { text: '14px', value: '14px' },
        { text: '16px', value: '16px' },
        { text: '18px', value: '18px' },
        { text: '24px', value: '24px' },
        { text: '30px', value: '30px' },
        { text: '36px', value: '36px' },
        { text: '48px', value: '48px' },
        { text: '60px', value: '60px' },
        { text: '72px', value: '72px' }
      ]
    },
    fontStyleOptions () {
      return [
        { text: 'normal', value: 'normal' },
        { text: 'italic', value: 'italic' },
        { text: 'oblique', value: 'oblique' }
      ]
    },
    lineHeightOptions () {
      return [
        { text: '---', value: null },
        { text: '100%', value: '100%' },
        { text: '125%', value: '125%' },
        { text: '150%', value: '150%' },
        { text: '200%', value: '200%' }
      ]
    },
    letterSpacingOptions () {
      return [
        { text: '-5px', value: '-5px' },
        { text: '-4px', value: '-4px' },
        { text: '-3px', value: '-3px' },
        { text: '-2px', value: '-2px' },
        { text: '-1px', value: '-1px' },
        { text: 'normal', value: null },
        { text: '0px', value: '0px' },
        { text: '1px', value: '1px' },
        { text: '2px', value: '2px' },
        { text: '3px', value: '3px' },
        { text: '4px', value: '4px' },
        { text: '5px', value: '5px' }
      ]
    },
    textAlignOptions () {
      return [
        { text: 'fa-align-left', value: 'left' },
        { text: 'fa-align-center', value: 'center' },
        { text: 'fa-align-right', value: 'right' },
        { text: 'fa-align-justify', value: 'justify' }
      ]
    },
    verticalAlignOptions () {
      return [
        { text: '/static/verticalAlignIcons/align-top.png', selected: '/static/verticalAlignIcons/align-top_w.png', value: 'top' },
        { text: '/static/verticalAlignIcons/align-middle.png', selected: '/static/verticalAlignIcons/align-middle_w.png', value: 'middle' },
        { text: '/static/verticalAlignIcons/align-bottom.png', selected: '/static/verticalAlignIcons/align-bottom_w.png', value: 'bottom' }
      ]
    },
    snsPartsAlignOptions () {
      return [
        { text: 'fa-align-left', value: 'left' },
        { text: 'fa-align-center', value: 'center' },
        { text: 'fa-align-right', value: 'right' }
      ]
    },
    mobileDisplayOptions () {
      return [
        { text: '縦並びレイアウト', value: 0 },
        { text: '横並びレイアウト', value: 1 },
      ]
    },
    widthOptions () {
      return [
        { text: 'テキストフィット', value: null },
        { text: '80%幅', value: '80%' },
        { text: 'ページ幅', value: '100%' }
      ]
    },
    marginOptions () {
      return [
        { text: 'fa-align-left', value: '0 auto 0 0' },
        { text: 'fa-align-center', value: '0 auto' },
        { text: 'fa-align-right', value: '0 0 0 auto' }
      ]
    },
    borderOptions () {
      return [
        { text: '---', value: 'none' },
        { text: 'ソリッド', value: 'solid' },
        { text: 'ダッシュ', value: 'dashed' },
        { text: 'ドット', value: 'dotted' }
      ]
    },
    snsPartDisplayOptions () {
      return [
        { text: 'アイコン', value: 'Icon' },
        { text: 'テキスト', value: 'Text' },
        { text: 'アイコン + テキスト', value: 'IconText' }
      ]
    }
  },
  methods: {
    // ラベルの設定
    initLabelText (target) {
      let labelText = null
      switch (target) {
        case 'font-family-name':
          labelText = 'フォント'
          break
        case 'font-size':
          labelText = 'サイズ'
          break
        case 'font-style':
          labelText = 'Style'
          break
        case 'letter-spacing':
          labelText = '文字間隔'
          break
        case 'line-height':
          labelText = '行間'
          break
        case 'text-align':
          labelText = 'Align'
          break
        case 'vertical-align':
          labelText = '垂直位置'
          break
        case 'width':
          labelText = 'ボタン幅'
          break
        case 'data-display-sns':
          labelText = '表示形式'
          break
        case 'flg-side':
          labelText = 'モバイル表示'
          break
        default:
          // 罫線
          if (/border/.test(target)) {
            const targetText = this.target.replace(/inner_/, '').replace(/boxedtext_/, '').replace(/imagecard_/, '')
            if (targetText === 'border') {
              labelText = '枠線'
            } else if (targetText === 'border-top') {
              labelText = '枠線 上'
            } else if (targetText === 'border-bottom') {
              labelText = '枠線 下'
            }
          }
      }
      return labelText
    },
    // 選択肢の設定
    initOptions (target) {
      let options = []
      switch (target) {
        case 'font-family-name':
          options = this.fontFamilyOptions
          break
        case 'font-size':
          options = this.fontSizeOptions
          break
        case 'font-style':
          options = this.fontStyleOptions
          break
        case 'letter-spacing':
          options = this.letterSpacingOptions
          break
        case 'line-height':
          options = this.lineHeightOptions
          break
        case 'text-align':
          options = this.textAlignOptions
          break
        case 'vertical-align':
          options = this.verticalAlignOptions
          break
        case 'width':
          options = this.widthOptions
          break
        case 'margin':
          options = this.marginOptions
          break
        case 'align':
          options = this.snsPartsAlignOptions
          break
        case 'data-display-sns':
          options = this.snsPartDisplayOptions
          break
        case 'flg-side':
          options = this.mobileDisplayOptions
          break
        default:
          if (/border/.test(target)) {
            options = this.borderOptions
          }
      }
      return options
    },
  }
}
